// eslint-disable-next-line no-restricted-syntax
export enum Environment {
  Production = "production",
  Development = "development",
  Preview = "preview",
  Unknown = "unknown",
}

export function getHostnames() {
  return {
    dev: ["admin.instacar.dev.instacover.ai", "instacar.dev.instacover.ai", "instacar.dev.instaclaim.ai"],
    prod: ["admin.instacar.instacover.ai", "instacar.instacover.ai", "instacar.instaclaim.ai"],
    preview: [
      "admin.instacar.preview.instacover.ai",
      "instacar.preview.instacover.ai",
      "instacar.preview.instaclaim.ai",
    ],
  }
}

export function resolveEnvironment() {
  const { dev, prod, preview } = getHostnames()
  const hostname = window.location.hostname.toLowerCase()
  if (dev.includes(hostname)) {
    return Environment.Development
  }

  if (prod.includes(hostname)) {
    return Environment.Production
  }

  if (preview.includes(hostname)) {
    return Environment.Preview
  }

  return Environment.Unknown
}

export function isDev(): boolean {
  return resolveEnvironment() === Environment.Development
}

export function isProd(): boolean {
  return resolveEnvironment() === Environment.Production
}

export function isPreview(): boolean {
  return resolveEnvironment() === Environment.Preview
}

export function isLocalDev(): boolean {
  return process.env.NODE_ENV !== "production"
}
